/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ rate: NonNullable<unknown> }} Media_Import_Update_Frame_Rate_PromptInputs */

const en_media_import_update_frame_rate_prompt = /** @type {(inputs: Media_Import_Update_Frame_Rate_PromptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Media frame rate detected (${i?.rate}). Would you like to update the project frame rate?`)
};

const fr_media_import_update_frame_rate_prompt = /** @type {(inputs: Media_Import_Update_Frame_Rate_PromptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Frequence d'images detectee (${i?.rate}). Voulez-vous mettre a jour la frequence d'images du projet ?`)
};

const de_media_import_update_frame_rate_prompt = /** @type {(inputs: Media_Import_Update_Frame_Rate_PromptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Medienbildrate erkannt (${i?.rate}). Möchten Sie die Projektbildrate aktualisieren?`)
};

const it_media_import_update_frame_rate_prompt = /** @type {(inputs: Media_Import_Update_Frame_Rate_PromptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rilevata frequenza fotogrammi del supporto (${i?.rate}). Vuoi aggiornare la frequenza fotogrammi del progetto?`)
};

const ru_media_import_update_frame_rate_prompt = /** @type {(inputs: Media_Import_Update_Frame_Rate_PromptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Обнаружена частота кадров медиафайла (${i?.rate}). Хотите обновить частоту кадров проекта?`)
};

const es_media_import_update_frame_rate_prompt = /** @type {(inputs: Media_Import_Update_Frame_Rate_PromptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Velocidad de fotogramas detectada (${i?.rate}). ¿Desea actualizar la velocidad de fotogramas del proyecto?`)
};

const zh_cn2_media_import_update_frame_rate_prompt = /** @type {(inputs: Media_Import_Update_Frame_Rate_PromptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`检测到媒体帧速率 (${i?.rate})。是否要更新项目帧速率？`)
};

const ja_media_import_update_frame_rate_prompt = /** @type {(inputs: Media_Import_Update_Frame_Rate_PromptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`メディアのフレームレートが検出されました (${i?.rate})。プロジェクトのフレームレートを更新しますか?`)
};

const hi_media_import_update_frame_rate_prompt = /** @type {(inputs: Media_Import_Update_Frame_Rate_PromptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`मीडिया फ्रेम दर का पता चला (${i?.rate})। क्या आप प्रोजेक्ट फ्रेम दर को अपडेट करना चाहेंगे?`)
};

const pt_pt2_media_import_update_frame_rate_prompt = /** @type {(inputs: Media_Import_Update_Frame_Rate_PromptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Taxa de quadros da mídia detectada (${i?.rate}). Deseja atualizar a taxa de quadros do projeto?`)
};

/**
* | output |
* | --- |
* | "Media frame rate detected ({rate}). Would you like to update the project frame rate?" |
*
* @param {Media_Import_Update_Frame_Rate_PromptInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_import_update_frame_rate_prompt = /** @type {((inputs: Media_Import_Update_Frame_Rate_PromptInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Import_Update_Frame_Rate_PromptInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_media_import_update_frame_rate_prompt(inputs)
	if (locale === "de") return de_media_import_update_frame_rate_prompt(inputs)
	if (locale === "it") return it_media_import_update_frame_rate_prompt(inputs)
	if (locale === "ru") return ru_media_import_update_frame_rate_prompt(inputs)
	if (locale === "es") return es_media_import_update_frame_rate_prompt(inputs)
	if (locale === "zh-CN") return zh_cn2_media_import_update_frame_rate_prompt(inputs)
	if (locale === "ja") return ja_media_import_update_frame_rate_prompt(inputs)
	if (locale === "hi") return hi_media_import_update_frame_rate_prompt(inputs)
	if (locale === "pt-PT") return pt_pt2_media_import_update_frame_rate_prompt(inputs)
	return en_media_import_update_frame_rate_prompt(inputs)
});